module.exports = require("core-js-pure/stable/object/set-prototype-of");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/object/set-prototype-of.js
// module id = 422
// module chunks = 0 1